// React / Next
import { useEffect } from 'react';
import { createFileRoute, useLocation } from '@tanstack/react-router';

// Components
import { HeroSection } from '../components/HeroSection/HeroSection';
import { WhyHireSection } from '../components/WhyHireSection/WhyHireSection';
import { CapabilitiesSection } from '../components/CapabilitiesSection/CapabilitiesSection';
// import { UseCasesSection } from '../components/UseCasesSection/UseCasesSection';
import { ArchieShowcaseSection } from '../components/ArchieShowcaseSection/ArchieShowcaseSection';
import { WhyHireArchieText } from '../components/WhyHireArchieText/WhyHireArchieText';
import { TrustSection } from '../components/TrustSection/TrustSection';
import { HireArchieCTA } from '../components/HireArchieCTA/HireArchieCTA';
import { NewsletterSection } from '../components/NewsletterSection/NewsletterSection';
import { SEO } from '../components/SEO/SEO';

// Misc
import { getAnnouncementBanner } from '../lib/sanity';

export const Route = createFileRoute('/')({
  loader: async () => {
    const banner = await getAnnouncementBanner();
    return { banner };
  },
  component: HomePage,
});

function HomePage() {
  const location = useLocation();
  const { banner } = Route.useLoaderData();

  // Handle scroll to hash section when navigating from other pages
  useEffect(() => {
    if (location.hash) {
      // Small delay to ensure DOM is ready
      const timeoutId = setTimeout(() => {
        const element = document.querySelector(`#${location.hash}`);
        if (element) {
          const navbarHeight = 80;
          const elementPosition = element.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: elementPosition - navbarHeight,
            behavior: 'smooth',
          });
        }
      }, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [location.hash]);

  return (
    <div className="flex flex-col items-center bg-white">
      <SEO
        keywords="AI accounting, AI staff accountant, accounting automation, accounting firm capacity, automated bookkeeping"
        canonicalUrl="/"
      />

      {/* Hero Section */}
      <HeroSection banner={banner} />

      {/* Why Would You Hire Archie - Persona Cards */}
      <WhyHireSection />

      {/* What Archie Can Do - Capability Cards */}
      <CapabilitiesSection />

      {/* How Accounting Teams Work With Archie - Use Cases */}
      {/* <UseCasesSection /> */}

      {/* Archie Showcase - Capabilities Demo */}
      <ArchieShowcaseSection />

      {/* Why Hire Archie - Text Section */}
      <WhyHireArchieText />

      {/* Why Trust Archie - Security */}
      <TrustSection />

      {/* Hire Archie CTA */}
      <HireArchieCTA />

      {/* Newsletter Signup */}
      <NewsletterSection />
    </div>
  );
}
